import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Table from '@/sections/ComparisonTable';
import { SectionHeadline } from '@/components/SectionHeadline';
import { LINKS } from '@/constants/links';
import { useHash } from '@/hooks/useHash';
import { RepresentativeExample } from '@/sections/RepresentativeExample';
import { Link } from '@/components/links';
import { ComparisonTableCategory } from '@/types/comparisonTable';
function MaxiComparisonTable() {
  const $ = _c(83);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["revolvingLoan", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const hash = useHash();
  let t1;
  if ($[1] !== t) {
    t1 = t("revolvingLoan:flexibleTable.categories.1.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("revolvingLoan:flexibleTable.categories.1.items.1.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = LINKS();
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = {
      title: t2,
      to: t3.aboutDeferredPayment,
      left: true,
      right: true
    };
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("revolvingLoan:flexibleTable.categories.1.items.2.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = LINKS();
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = {
      title: t5,
      to: t6.payInThree,
      left: true,
      right: true
    };
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("revolvingLoan:flexibleTable.categories.1.items.3.title");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = LINKS();
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8) {
    t10 = {
      title: t8,
      to: t9.loan,
      left: true,
      right: true
    };
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t("revolvingLoan:flexibleTable.categories.1.items.4.title");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = LINKS();
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11) {
    t13 = {
      title: t11,
      to: t12.card,
      left: false,
      right: true
    };
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t("revolvingLoan:flexibleTable.categories.1.items.5.title");
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = LINKS();
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14) {
    t16 = {
      title: t14,
      to: t15.postponeDueDate,
      left: false,
      right: true
    };
    $[26] = t14;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t) {
    t17 = t("revolvingLoan:flexibleTable.categories.1.items.6.title");
    $[28] = t;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = LINKS();
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t17) {
    t19 = {
      title: t17,
      to: t18.installments,
      left: false,
      right: true
    };
    $[31] = t17;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t) {
    t20 = t("revolvingLoan:flexibleTable.categories.1.items.7.title");
    $[33] = t;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = LINKS();
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t20) {
    t22 = {
      title: t20,
      to: t21.bankTransfer,
      left: false,
      right: true
    };
    $[36] = t20;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t) {
    t23 = t("revolvingLoan:flexibleTable.categories.1.items.8.title");
    $[38] = t;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = LINKS();
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== t23) {
    t25 = {
      title: t23,
      to: t24.card,
      left: false,
      right: true
    };
    $[41] = t23;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== t10 || $[44] !== t13 || $[45] !== t16 || $[46] !== t19 || $[47] !== t22 || $[48] !== t25 || $[49] !== t4 || $[50] !== t7) {
    t26 = [t4, t7, t10, t13, t16, t19, t22, t25];
    $[43] = t10;
    $[44] = t13;
    $[45] = t16;
    $[46] = t19;
    $[47] = t22;
    $[48] = t25;
    $[49] = t4;
    $[50] = t7;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t1 || $[53] !== t26) {
    t27 = [{
      title: t1,
      items: t26
    }];
    $[52] = t1;
    $[53] = t26;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  const categories = t27;
  let t28;
  let t29;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div id="maxi" />;
    t29 = <div id="mini" />;
    $[55] = t28;
    $[56] = t29;
  } else {
    t28 = $[55];
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t) {
    t30 = t("revolvingLoan:flexibleTable.title");
    $[57] = t;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t30) {
    t31 = <SectionHeadline className="mb-12 md:mb-16" anchorKey="revolvingLoan.flexibleTable.title">{t30}</SectionHeadline>;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  const t32 = hash === "maxi";
  const t33 = hash === "maxi" ? 1 : 2;
  let t34;
  if ($[61] !== t) {
    t34 = t("revolvingLoan:flexibleTable.mini.title");
    $[61] = t;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== t) {
    t35 = t("revolvingLoan:flexibleTable.maxi.title");
    $[63] = t;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t34 || $[66] !== t35) {
    t36 = {
      left: t34,
      right: t35
    };
    $[65] = t34;
    $[66] = t35;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== categories || $[69] !== t32 || $[70] !== t33 || $[71] !== t36) {
    t37 = <Table isSecondColumnActive={t32} primaryColumn={t33} coloredHeaderBgClassName="bg-white text-black!" headerClassName="text-black!" titles={t36} categories={categories} />;
    $[68] = categories;
    $[69] = t32;
    $[70] = t33;
    $[71] = t36;
    $[72] = t37;
  } else {
    t37 = $[72];
  }
  let t38;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = LINKS();
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  const t39 = t38.allProducts;
  let t40;
  if ($[74] !== t) {
    t40 = t("revolvingLoan:flexibleTable.text");
    $[74] = t;
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] !== t40) {
    t41 = <div className="flex flex-col"><Link to={t39} analyticsParam="revolvingLoanAllProductsCTA" testId="revolvingLoanAllProductsCTA" className="my-10 text-center">{t40}</Link></div>;
    $[76] = t40;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  let t42;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="mx-auto mt-4 max-w-[47.5rem] md:my-16 lg:my-12" id="representative-example"><RepresentativeExample className="bg-white" variant="default" /></div>;
    $[78] = t42;
  } else {
    t42 = $[78];
  }
  let t43;
  if ($[79] !== t31 || $[80] !== t37 || $[81] !== t41) {
    t43 = <>{t28}{t29}<div className="relative px-4 py-10 md:py-20"><div className="relative z-10">{t31}{t37}{t41}{t42}</div></div></>;
    $[79] = t31;
    $[80] = t37;
    $[81] = t41;
    $[82] = t43;
  } else {
    t43 = $[82];
  }
  return t43;
}
export default MaxiComparisonTable;